import { render, staticRenderFns } from "./ClbrtnHistDetail.vue?vue&type=template&id=3e5afb9a&scoped=true"
import script from "./ClbrtnHistDetail.vue?vue&type=script&lang=js"
export * from "./ClbrtnHistDetail.vue?vue&type=script&lang=js"
import style0 from "./ClbrtnHistDetail.vue?vue&type=style&index=0&id=3e5afb9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5afb9a",
  null
  
)

export default component.exports